import styled from 'styled-components';

export const PageStyle = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

export const CarbonButton = styled.button`
width: fit-content;
height: fit-content;
font-size: 18px;
color: ${({ colored }) => (colored ? '#fff' : '#33682c')};
padding: 10px 25px 10px 25px;
background: ${({ colored }) => (colored ? '#33682c' : '#fff')};
border: none;
border-radius: 10px;

&:hover{
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
}
`;
